/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ContractActionV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * The uuid of the contract linked to this contract-action. As 8-4-4-4-12 format.
   */
  contractId: string;
  /**
   * The type of the contract action.
   */
  type: ContractActionV1Dto.type;
  /**
   * The type of the action person.
   */
  actingBy: ContractActionV1Dto.actingBy;
  /**
   * The maximum count of actions
   */
  maxCount?: number | null;
  /**
   * The extension value
   */
  extensionValue?: number | null;
  /**
   * The unit type of the extension.
   */
  extensionUnit?: ContractActionV1Dto.extensionUnit | null;
  /**
   * The notice period value
   */
  noticePeriod?: number | null;
  /**
   * The unit type of the notice period.
   */
  noticePeriodUnit?: ContractActionV1Dto.noticePeriodUnit | null;
  /**
   * The resiliation date of the contract action.
   */
  resiliationDate?: string | null;
  /**
   * A longer comment of the contract action
   */
  comment?: string | null;
  /**
   * the position of the contract action
   */
  position?: number | null;
  /**
   * The already used number of actions
   */
  numberOfUses?: number | null;
  /**
   * status of the contract action
   */
  status?: ContractActionV1Dto.status | null;
};
export namespace ContractActionV1Dto {
  /**
   * The type of the contract action.
   */
  export enum type {
    ACTIVE = 'active',
    AUTOMATIC = 'automatic',
    AUTOMATIC_EXTENSION = 'automatic_extension',
    SPECIAL_RESILIATION = 'special_resiliation',
    TERMINATION = 'termination',
    OTHER = 'other',
  }
  /**
   * The type of the action person.
   */
  export enum actingBy {
    TENANT = 'tenant',
    LANDLORD = 'landlord',
    TENANT_OR_LANDLORD = 'tenant_or_landlord',
  }
  /**
   * The unit type of the extension.
   */
  export enum extensionUnit {
    DAY = 'day',
    WEEK = 'week',
    MONTH = 'month',
    YEAR = 'year',
  }
  /**
   * The unit type of the notice period.
   */
  export enum noticePeriodUnit {
    DAY = 'day',
    WEEK = 'week',
    MONTH = 'month',
    YEAR = 'year',
  }
  /**
   * status of the contract action
   */
  export enum status {
    AVAILABLE = 'Available',
    UNAVAILABLE = 'Unavailable',
    ACTIVE = 'Active',
    COMPLETED = 'Completed',
    SKIP = 'Skip',
  }
}
